import React, { useState } from "react";
import ctl from "@netlify/classnames-template-literals";
import { Menu } from "./menu";
import { PLink } from "components";
import LogoLight from "svgs/parkway-light.svg";
import LogoDark from "svgs/parkway-dark.svg";

const NavBar = ({ theme }) => {
  const [openMenu, setOpenMenu] = useState(false);

  const onToggle = () => {
    setOpenMenu(!openMenu);
  };

  const mainHeaderStyle = ctl(`
  ${mainHeaderBaseStyle} 
  ${openMenu && "h-full"}
  ${mainHeaderTheme[theme]}
  `);

  return (
    <header className={mainHeaderStyle}>
      <nav className={navStyle}>
        <PLink to="/">{logo[theme]}</PLink>

        <Menu openMenu={openMenu} onToggle={onToggle} theme={theme} />
      </nav>
    </header>
  );
};

const mainHeaderBaseStyle = ctl(`
fixed
top-0
left-0
w-full
z-[9999]
lg:h-auto
`);

const mainHeaderTheme = {
  dark: `
  bg-secondary
  lg:text-secondary-100
  text-secondary
  `,
  light: `
  bg-secondary-100
  text-secondary
  `,
};
const navStyle = ctl(`
  flex
  items-center
  justify-between
  lg:px-6
  px-4
  py-5
  lg:py-2
  max-w-[1512px]
  mx-auto
`);

const logo = {
  dark: <LogoLight width="149" />,
  light: <LogoDark width="149" />,
};

NavBar.defaultProps = {
  theme: "dark",
};

export { NavBar };
